import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Calendar, User } from 'lucide-react';
import { useApiResource } from '../hooks/useApiResource';
import { DetailPageLayout, DetailPageState } from '../components/DetailPageLayout';
import { getArticleCategoryLabel } from '../lib/contentLabels';

export default function InsightDetail() {
  const { slug } = useParams();
  const { i18n } = useTranslation();
  const { data: article, loading, error } = useApiResource(`/articles/${slug}`, { lang: i18n.language });

  const getLocalizedField = (item, field) => {
    if (i18n.language === 'en' && item[`${field}_en`]) {
      return item[`${field}_en`];
    }
    return item[field];
  };

  if (loading) {
    return <DetailPageState compact>Loading...</DetailPageState>;
  }

  if (!article) {
    return <DetailPageState compact>{error ? 'Failed to load article.' : 'Article not found.'}</DetailPageState>;
  }

  const title = getLocalizedField(article, 'title');
  const content = getLocalizedField(article, 'content');
  const dateLabel = new Date(article.published_at).toLocaleDateString(i18n.language === 'en' ? 'en-US' : 'ru-RU');
  const paragraphs = (content || '').split(/\n+/).filter(Boolean);
  const categoryLabel = getArticleCategoryLabel(article.category, i18n.language);

  return (
    <DetailPageLayout compact backTo="/insights" backLabel={i18n.language === 'en' ? 'Back to insights' : 'Назад к инсайтам'}>
        <div className="glass detail-page-card">
          <div className="relative h-72 md:h-96">
            <img src={article.image_url} alt={title} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
          </div>
          <div className="p-8 md:p-10 space-y-6">
            <div className="text-xs uppercase tracking-widest text-[#E11D2E]">{categoryLabel}</div>
            <h1 className="detail-page-title">{title}</h1>
            <div className="detail-page-meta flex items-center gap-4">
              <div className="flex items-center gap-2">
                <User className="w-4 h-4" />
                <span>{article.author}</span>
              </div>
              <div className="flex items-center gap-2">
                <Calendar className="w-4 h-4" />
                <span>{dateLabel}</span>
              </div>
            </div>
            <div className="detail-page-body space-y-4">
              {paragraphs.map((paragraph, idx) => (
                <p key={idx}>{paragraph}</p>
              ))}
            </div>
          </div>
        </div>
    </DetailPageLayout>
  );
}
